<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em">Deborah Hocutt received her B.A. from Virginia Wesleyan University and her M.A. from Regent University. She worked as the Director of Education at the Library of Virginia and was Executive Director for the Virginia Center for the Book before moving into the field of literary management.</p><br/>
<p style="text-indent:00em"><em>A Settler’s Passion</em> is her first novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?efa505ba